import { Artifacts } from './artwork/Artifacts';
import { Cycle } from './artwork/Cycle';
import { EnvJson } from './artwork/EnvJson';
import { File } from './artwork/File';
import { Projects } from './artwork/Projects';
import { Tenant } from './artwork/Tenant';
import { User } from './artwork/User';
import { FormManager } from './cm/FormManager';
import { createServiceAxios } from './lib/awAxios';

// Create independent Client for CM service
const cmClient = createServiceAxios('cm');
export const CM_SERVICE = {
  formManager: new FormManager(cmClient),
};

// Create independent Client for Artwork service
const artworkClient = createServiceAxios('artwork');
export const ARTWORK_SERVICE = {
  projects: new Projects(artworkClient),
  tenant: new Tenant(artworkClient),
  user: new User(artworkClient),
  envJson: new EnvJson(artworkClient),
  file: new File(artworkClient),
  instance: artworkClient.instance,
  artifacts: new Artifacts(artworkClient),
  cycle: new Cycle(artworkClient),
};

const commonUamClient = createServiceAxios('uam');
export const COMMON_UAM_SERVICE = {
  instance: commonUamClient.instance,
};

const docsClient = createServiceAxios('docs');
export const DOCS_SERVICE = {
  instance: docsClient.instance,
};


